"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var Label_1 = require("components/Label");
var Select_1 = require("components/Select");
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var validations_1 = require("lib/functions/validations");
var findErrors_1 = require("lib/functions/findErrors");
var rules = {
    program: validations_1.mandatory
};
var Program = (function (_super) {
    __extends(Program, _super);
    function Program(props) {
        var _this = _super.call(this, props) || this;
        _this.errors = {};
        _this.onChange = _this.onChange.bind(_this);
        _this.json_data = props.model.json_data;
        _this.onModel = _this.onModel.bind(_this);
        _this.isValid = _this.isValid.bind(_this);
        props.model.dispatcher.addListener(_this.onModel);
        return _this;
    }
    Object.defineProperty(Program.prototype, "dataStore", {
        get: function () {
            return this.props.model.dataStore;
        },
        enumerable: true,
        configurable: true
    });
    Program.prototype.onModel = function () {
        this.json_data = this.props.model.json_data;
        this.forceUpdate();
    };
    Program.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.props.model.dispatcher.dispatch();
                this.props.model.addValidateFunction("validateProgram", this.isValid);
                return [2];
            });
        });
    };
    Program.prototype.componentWillUnmount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.props.model.removeValidateFunction("validateProgram");
                this.props.model.dispatcher.removeListener(this.onModel);
                return [2];
            });
        });
    };
    Program.prototype.onChange = function (id, value) {
        this.json_data[id] = value;
        console.log("validateProgram", this.json_data);
        this.forceUpdate();
    };
    Program.prototype.isValid = function () {
        console.log("Validate Program");
        var _a = findErrors_1.findErrors(this.json_data, rules), isValid = _a.isValid, errors = _a.errors;
        this.errors = errors;
        return isValid;
    };
    Program.prototype.render = function () {
        var _a = this, json_data = _a.json_data, onChange = _a.onChange, errors = _a.errors;
        return (React.createElement("section", { className: "section-content" },
            React.createElement("h2", { className: "section-title" }, "PROGRAM APPLIED FOR"),
            React.createElement("article", null,
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-xs-12 col-md-6" },
                        React.createElement(Label_1.Label, { htmlFor: "program", text: "Select a program", required: true }),
                        React.createElement(Select_1.Select, { id: "program", json_data: json_data, onChange: onChange, options: this.dataStore.programs, errors: errors }))))));
    };
    __decorate([
        mobx_1.observable
    ], Program.prototype, "errors", void 0);
    Program = __decorate([
        mobx_react_1.observer
    ], Program);
    return Program;
}(react_1.Component));
exports.Program = Program;
//# sourceMappingURL=data:application/json;base64,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